import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { createId } from '@core/util/file';
import { MatterMortgagePriority } from '@models/mortgage';
import {
	TitleInsurancePolicy,
	TitleInsurancePolicyType,
} from '@models/title-insurance';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { SelectedMatter } from '@state/matter/matter.selectors';
import {
	DropdownOption,
	DropdownResult,
} from 'src/app/shared/atomic/atoms/dropdown-options/dropdown-options.component';

export interface AddPolicyModalData {
	policy: TitleInsurancePolicy;
}

@Component({
	selector: 'app-add-policy-modal',
	templateUrl: './add-policy-modal.component.html',
	standalone: false,
})
export class AddPolicyModalComponent implements OnInit {
	public policyType: TitleInsurancePolicyType = TitleInsurancePolicyType.LENDER;
	public priority: MatterMortgagePriority = MatterMortgagePriority.PRIORITY_1;
	public titleInsurancePolicyType = TitleInsurancePolicyType;
	public name: string;
	public policyNumber: string;
	public insuredAmount: number;
	public id: string;
	public editing = false;
	public policyTypeOptions = [];

	@SelectSnapshot(SelectedMatter.titleInsurancePolicies)
	policies: TitleInsurancePolicy[];

	public priorityOptions: DropdownOption<MatterMortgagePriority>[] = [
		{ name: 'First', value: MatterMortgagePriority.PRIORITY_1 },
		{ name: 'Second', value: MatterMortgagePriority.PRIORITY_2 },
		{ name: 'Third', value: MatterMortgagePriority.PRIORITY_3 },
		{ name: 'Fourth', value: MatterMortgagePriority.PRIORITY_4 },
		{ name: 'Fifth', value: MatterMortgagePriority.PRIORITY_5 },
	];

	constructor(
		private dialogRef: MatDialogRef<AddPolicyModalComponent>,
		@Inject(MAT_DIALOG_DATA) public _data: AddPolicyModalData,
	) {}

	ngOnInit(): void {
		if (this._data.policy) {
			this.editing = true;
			this.policyType = this._data.policy.type;
			this.name = this._data.policy.name;
			this.policyNumber = this._data.policy.number;
			this.insuredAmount = this._data.policy.insuredAmount;
			this.priority = this._data.policy.priority;
			this.id = this._data.policy.id;
		}

		this.policyTypeOptions = [
			{ label: 'Lender', value: TitleInsurancePolicyType.LENDER },
		];

		if (
			!this.policies?.find((p) => p.type === TitleInsurancePolicyType.OWNER) ||
			this.policyType === TitleInsurancePolicyType.OWNER
		) {
			this.policyTypeOptions.push({
				label: 'Owner',
				value: TitleInsurancePolicyType.OWNER,
			});
		}
	}

	close() {
		this.dialogRef.close();
	}

	addPolicy() {
		const policy: TitleInsurancePolicy = {
			type: this.policyType,
			name: this.name || '',
			number: this.policyNumber || '',
			insuredAmount: this.insuredAmount || 0,
			id: this.id || createId(),
		};

		if (this.policyType === TitleInsurancePolicyType.LENDER) {
			policy.priority = this.priority;
		}

		this.dialogRef.close(policy);
	}

	selectPriority(
		event: DropdownResult<DropdownOption<MatterMortgagePriority>>,
	) {
		this.priority = event.result.value;
	}

	get priorityLabel() {
		return this.priorityOptions.find((o) => o.value === this.priority)?.name;
	}
}
